export const config = {
  autoFocus: true,
  menuIsOpen: true,
  isClearable: false,
  openMenuOnFocus: true,
  tabSelectsValue: false,
  backspaceRemovesValue: false,
  controlShouldRenderValue: false,
  menuShouldScrollIntoView: true,
  classNamePrefix: "select",
};

export const multiSelectConfig = (hasError: boolean) => ({
  isMulti: true,
  isClearable: false,
  openMenuOnFocus: true,
  tabSelectsValue: false,
  closeMenuOnSelect: false,
  menuShouldScrollIntoView: true,
  classNamePrefix: hasError ? "has-error multi-select" : "multi-select",
});
